import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'
import { createSelector } from 'reselect'

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX].data

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

export const selectors = {
  notifications: createSelector(selectData, (state) => state.notifications),
  notificationsCount: createSelector(
    selectData,
    (state) => state.notificationsCount
  ),
}
